export const webPortfolio = [
    {
        id: 1,
        title: "Finanboutique AG Website",
        img: "img/finanzboutique_website.png",
        link: "https://www.finanzboutique.com/",
    },
    {
        id: 2,
        title: "This Website",
        img: "img/portfolio_website.png",
        link: "https://github.com/nurzeinab/portfolio",
    },
    
]

export const mobilePortfolio = [
    {
        id: 1,
        title: "Coming soon",
        img: "img/laptop-g089ca11b4_1920.jpg",
       
    },
   
]